export const NATIONALITIES = [
  // === Maghreb / Maroc en premier ===
  { flag: '🇲🇦', fr: 'Marocaine', ar: 'مغربية', code: 'MA' },
  { flag: '🇩🇿', fr: 'Algérienne', ar: 'جزائرية', code: 'DZ' },
  { flag: '🇹🇳', fr: 'Tunisienne', ar: 'تونسية', code: 'TN' },
  { flag: '🇱🇾', fr: 'Libyenne', ar: 'ليبية', code: 'LY' },
  { flag: '🇲🇷', fr: 'Mauritanienne', ar: 'موريتانية', code: 'MR' },
  // === Pays arabes ===
  { flag: '🇪🇬', fr: 'Égyptienne', ar: 'مصرية', code: 'EG' },
  { flag: '🇸🇦', fr: 'Saoudienne', ar: 'سعودية', code: 'SA' },
  { flag: '🇦🇪', fr: 'Émiratie', ar: 'إماراتية', code: 'AE' },
  { flag: '🇰🇼', fr: 'Koweïtienne', ar: 'كويتية', code: 'KW' },
  { flag: '🇶🇦', fr: 'Qatarie', ar: 'قطرية', code: 'QA' },
  { flag: '🇧🇭', fr: 'Bahreïnienne', ar: 'بحرينية', code: 'BH' },
  { flag: '🇴🇲', fr: 'Omanaise', ar: 'عمانية', code: 'OM' },
  { flag: '🇯🇴', fr: 'Jordanienne', ar: 'أردنية', code: 'JO' },
  { flag: '🇱🇧', fr: 'Libanaise', ar: 'لبنانية', code: 'LB' },
  { flag: '🇸🇾', fr: 'Syrienne', ar: 'سورية', code: 'SY' },
  { flag: '🇮🇶', fr: 'Irakienne', ar: 'عراقية', code: 'IQ' },
  { flag: '🇾🇪', fr: 'Yéménite', ar: 'يمنية', code: 'YE' },
  { flag: '🇵🇸', fr: 'Palestinienne', ar: 'فلسطينية', code: 'PS' },
  { flag: '🇸🇩', fr: 'Soudanaise', ar: 'سودانية', code: 'SD' },
  { flag: '🇸🇸', fr: 'Sud-soudanaise', ar: 'جنوب سودانية', code: 'SS' },
  { flag: '🇸☉', fr: 'Somalienne', ar: 'صومالية', code: 'SO' },
  { flag: '🇩🇯', fr: 'Djiboutienne', ar: 'جيبوتية', code: 'DJ' },
  { flag: '🇰🇲', fr: 'Comorienne', ar: 'قمرية', code: 'KM' },
  // === Europe ===
  { flag: '🇫🇷', fr: 'Française', ar: 'فرنسية', code: 'FR' },
  { flag: '🇪🇸', fr: 'Espagnole', ar: 'إسبانية', code: 'ES' },
  { flag: '🇩🇪', fr: 'Allemande', ar: 'ألمانية', code: 'DE' },
  { flag: '🇮🇹', fr: 'Italienne', ar: 'إيطالية', code: 'IT' },
  { flag: '🇬🇧', fr: 'Britannique', ar: 'بريطانية', code: 'GB' },
  { flag: '🇧🇪', fr: 'Belge', ar: 'بلجيكية', code: 'BE' },
  { flag: '🇳🇱', fr: 'Néerlandaise', ar: 'هولندية', code: 'NL' },
  { flag: '🇵🇹', fr: 'Portugaise', ar: 'برتغالية', code: 'PT' },
  { flag: '🇨🇭', fr: 'Suisse', ar: 'سويسرية', code: 'CH' },
  { flag: '🇦🇹', fr: 'Autrichienne', ar: 'نمساوية', code: 'AT' },
  { flag: '🇸🇪', fr: 'Suédoise', ar: 'سويدية', code: 'SE' },
  { flag: '🇳☉', fr: 'Norvégienne', ar: 'نرويجية', code: 'NO' },
  { flag: '🇩🇰', fr: 'Danoise', ar: 'دانماركية', code: 'DK' },
  { flag: '🇫🇮', fr: 'Finlandaise', ar: 'فنلندية', code: 'FI' },
  { flag: '🇮🇸', fr: 'Islandaise', ar: 'آيسلندية', code: 'IS' },
  { flag: '🇮🇪', fr: 'Irlandaise', ar: 'أيرلندية', code: 'IE' },
  { flag: '🇱🇺', fr: 'Luxembourgeoise', ar: 'لوكسمبورغية', code: 'LU' },
  { flag: '🇲🇨', fr: 'Monégasque', ar: 'موناكية', code: 'MC' },
  { flag: '🇦🇩', fr: 'Andorrane', ar: 'أندورية', code: 'AD' },
  { flag: '🇲🇹', fr: 'Maltaise', ar: 'مالطية', code: 'MT' },
  { flag: '🇨🇾', fr: 'Chypriote', ar: 'قبرصية', code: 'CY' },
  { flag: '🇵🇱', fr: 'Polonaise', ar: 'بولندية', code: 'PL' },
  { flag: '🇨🇿', fr: 'Tchèque', ar: 'تشيكية', code: 'CZ' },
  { flag: '🇸🇰', fr: 'Slovaque', ar: 'سلوفاكية', code: 'SK' },
  { flag: '🇭🇺', fr: 'Hongroise', ar: 'مجرية', code: 'HU' },
  { flag: '🇷🇴', fr: 'Roumaine', ar: 'رومانية', code: 'RO' },
  { flag: '🇧🇬', fr: 'Bulgare', ar: 'بلغارية', code: 'BG' },
  { flag: '🇬🇷', fr: 'Grecque', ar: 'يونانية', code: 'GR' },
  { flag: '🇦🇱', fr: 'Albanaise', ar: 'ألبانية', code: 'AL' },
  { flag: '🇲🇰', fr: 'Macédonienne', ar: 'مقدونية', code: 'MK' },
  { flag: '🇷🇸', fr: 'Serbe', ar: 'صربية', code: 'RS' },
  { flag: '🇭🇷', fr: 'Croate', ar: 'كرواتية', code: 'HR' },
  { flag: '🇸🇮', fr: 'Slovène', ar: 'سلوفينية', code: 'SI' },
  { flag: '🇧🇦', fr: 'Bosnienne', ar: 'بوسنية', code: 'BA' },
  { flag: '🇲🇪', fr: 'Monténégrine', ar: 'جبل أسود', code: 'ME' },
  { flag: '🇽🇰', fr: 'Kosovare', ar: 'كوسوفية', code: 'XK' },
  { flag: '🇹🇷', fr: 'Turque', ar: 'تركية', code: 'TR' },
  { flag: '🇷🇺', fr: 'Russe', ar: 'روسية', code: 'RU' },
  { flag: '🇺🇦', fr: 'Ukrainienne', ar: 'أوكرانية', code: 'UA' },
  { flag: '🇧🇾', fr: 'Biélorusse', ar: 'بيلاروسية', code: 'BY' },
  { flag: '🇲🇩', fr: 'Moldave', ar: 'مولدوفية', code: 'MD' },
  { flag: '🇱🇹', fr: 'Lituanienne', ar: 'ليتوانية', code: 'LT' },
  { flag: '🇱🇻', fr: 'Lettone', ar: 'لاتفية', code: 'LV' },
  { flag: '🇪🇪', fr: 'Estonienne', ar: 'إستونية', code: 'EE' },
  { flag: '🇬🇪', fr: 'Géorgienne', ar: 'جورجية', code: 'GE' },
  { flag: '🇦🇲', fr: 'Arménienne', ar: 'أرمينية', code: 'AM' },
  { flag: '🇦🇿', fr: 'Azerbaïdjanaise', ar: 'أذربيجانية', code: 'AZ' },
  // === Amériques ===
  { flag: '🇺🇸', fr: 'Américaine', ar: 'أمريكية', code: 'US' },
  { flag: '🇨🇦', fr: 'Canadienne', ar: 'كندية', code: 'CA' },
  { flag: '🇲🇽', fr: 'Mexicaine', ar: 'مكسيكية', code: 'MX' },
  { flag: '🇧🇷', fr: 'Brésilienne', ar: 'برازيلية', code: 'BR' },
  { flag: '🇦🇷', fr: 'Argentine', ar: 'أرجنتينية', code: 'AR' },
  { flag: '🇨🇱', fr: 'Chilienne', ar: 'تشيلية', code: 'CL' },
  { flag: '🇨🇴', fr: 'Colombienne', ar: 'كولومبية', code: 'CO' },
  { flag: '🇵🇪', fr: 'Péruvienne', ar: 'بيروفية', code: 'PE' },
  { flag: '🇻🇪', fr: 'Vénézuélienne', ar: 'فنزويلية', code: 'VE' },
  { flag: '🇪🇨', fr: 'Équatorienne', ar: 'إكوادورية', code: 'EC' },
  { flag: '🇧🇴', fr: 'Bolivienne', ar: 'بوليفية', code: 'BO' },
  { flag: '🇵🇾', fr: 'Paraguayenne', ar: 'باراغوية', code: 'PY' },
  { flag: '🇺🇾', fr: 'Uruguayenne', ar: 'أوروغوية', code: 'UY' },
  { flag: '🇬🇾', fr: 'Guyanienne', ar: 'غيانية', code: 'GY' },
  { flag: '🇸🇷', fr: 'Surinamaise', ar: 'سورينامية', code: 'SR' },
  { flag: '🇨🇺', fr: 'Cubaine', ar: 'كوبية', code: 'CU' },
  { flag: '🇩🇴', fr: 'Dominicaine', ar: 'دومينيكية', code: 'DO' },
  { flag: '🇭🇹', fr: 'Haïtienne', ar: 'هايتية', code: 'HT' },
  { flag: '🇯🇲', fr: 'Jamaïcaine', ar: 'جامايكية', code: 'JM' },
  { flag: '🇹🇹', fr: 'Trinidadienne', ar: 'ترينيدادية', code: 'TT' },
  { flag: '🇧🇸', fr: 'Bahaméenne', ar: 'باهامية', code: 'BS' },
  { flag: '🇧🇧', fr: 'Barbadienne', ar: 'بربادوسية', code: 'BB' },
  { flag: '🇬🇹', fr: 'Guatémaltèque', ar: 'غواتيمالية', code: 'GT' },
  { flag: '🇭🇳', fr: 'Hondurienne', ar: 'هندوراسية', code: 'HN' },
  { flag: '🇸🇻', fr: 'Salvadorienne', ar: 'سلفادورية', code: 'SV' },
  { flag: '🇳🇮', fr: 'Nicaraguayenne', ar: 'نيكاراغوية', code: 'NI' },
  { flag: '🇨🇷', fr: 'Costaricaine', ar: 'كوستاريكية', code: 'CR' },
  { flag: '🇵🇦', fr: 'Panaméenne', ar: 'بنمية', code: 'PA' },
  { flag: '🇧🇿', fr: 'Bélizienne', ar: 'بليزية', code: 'BZ' },
  // === Asie ===
  { flag: '🇨🇳', fr: 'Chinoise', ar: 'صينية', code: 'CN' },
  { flag: '🇯🇵', fr: 'Japonaise', ar: 'يابانية', code: 'JP' },
  { flag: '🇰🇷', fr: 'Coréenne (Sud)', ar: 'كورية جنوبية', code: 'KR' },
  { flag: '🇰🇵', fr: 'Coréenne (Nord)', ar: 'كورية شمالية', code: 'KP' },
  { flag: '🇮🇳', fr: 'Indienne', ar: 'هندية', code: 'IN' },
  { flag: '🇵🇰', fr: 'Pakistanaise', ar: 'باكستانية', code: 'PK' },
  { flag: '🇧🇩', fr: 'Bangladaise', ar: 'بنغلاديشية', code: 'BD' },
  { flag: '🇳🇵', fr: 'Népalaise', ar: 'نيبالية', code: 'NP' },
  { flag: '🇧🇹', fr: 'Bhoutanaise', ar: 'بوتانية', code: 'BT' },
  { flag: '🇱🇰', fr: 'Sri-lankaise', ar: 'سريلانكية', code: 'LK' },
  { flag: '🇲🇻', fr: 'Maldivienne', ar: 'مالديفية', code: 'MV' },
  { flag: '🇦🇫', fr: 'Afghane', ar: 'أفغانية', code: 'AF' },
  { flag: '🇮🇷', fr: 'Iranienne', ar: 'إيرانية', code: 'IR' },
  { flag: '🇮🇩', fr: 'Indonésienne', ar: 'إندونيسية', code: 'ID' },
  { flag: '🇲🇾', fr: 'Malaisienne', ar: 'ماليزية', code: 'MY' },
  { flag: '🇸🇬', fr: 'Singapourienne', ar: 'سنغافورية', code: 'SG' },
  { flag: '🇧🇳', fr: 'Brunéienne', ar: 'بروناية', code: 'BN' },
  { flag: '🇹🇭', fr: 'Thaïlandaise', ar: 'تايلندية', code: 'TH' },
  { flag: '🇵🇭', fr: 'Philippine', ar: 'فلبينية', code: 'PH' },
  { flag: '🇻🇳', fr: 'Vietnamienne', ar: 'فيتنامية', code: 'VN' },
  { flag: '🇰🇭', fr: 'Cambodgienne', ar: 'كمبودية', code: 'KH' },
  { flag: '🇱🇦', fr: 'Laotienne', ar: 'لاوسية', code: 'LA' },
  { flag: '🇲🇲', fr: 'Birmane', ar: 'بورمية', code: 'MM' },
  { flag: '🇹🇼', fr: 'Taïwanaise', ar: 'تايوانية', code: 'TW' },
  { flag: '🇭🇰', fr: 'Hong-kongaise', ar: 'هونغ كونغية', code: 'HK' },
  { flag: '🇲🇳', fr: 'Mongole', ar: 'منغولية', code: 'MN' },
  { flag: '🇰🇿', fr: 'Kazakhstanaise', ar: 'كازاخستانية', code: 'KZ' },
  { flag: '🇺🇿', fr: 'Ouzbèke', ar: 'أوزبكية', code: 'UZ' },
  { flag: '🇹🇲', fr: 'Turkmène', ar: 'تركمانستانية', code: 'TM' },
  { flag: '🇰🇬', fr: 'Kirghize', ar: 'قيرغيزستانية', code: 'KG' },
  { flag: '🇹🇯', fr: 'Tadjike', ar: 'طاجيكستانية', code: 'TJ' },
  // === Afrique ===
  { flag: '🇿🇦', fr: 'Sud-africaine', ar: 'جنوب إفريقية', code: 'ZA' },
  { flag: '🇳🇬', fr: 'Nigériane', ar: 'نيجيرية', code: 'NG' },
  { flag: '🇰🇪', fr: 'Kényane', ar: 'كينية', code: 'KE' },
  { flag: '🇪🇹', fr: 'Éthiopienne', ar: 'إثيوبية', code: 'ET' },
  { flag: '🇪🇷', fr: 'Érythréenne', ar: 'إريترية', code: 'ER' },
  { flag: '🇺🇬', fr: 'Ougandaise', ar: 'أوغندية', code: 'UG' },
  { flag: '🇹🇿', fr: 'Tanzanienne', ar: 'تنزانية', code: 'TZ' },
  { flag: '🇷🇼', fr: 'Rwandaise', ar: 'رواندية', code: 'RW' },
  { flag: '🇧🇮', fr: 'Burundaise', ar: 'بوروندية', code: 'BI' },
  { flag: '🇲🇼', fr: 'Malawienne', ar: 'ملاوية', code: 'MW' },
  { flag: '🇲🇿', fr: 'Mozambicaine', ar: 'موزمبيقية', code: 'MZ' },
  { flag: '🇿🇲', fr: 'Zambienne', ar: 'زامبية', code: 'ZM' },
  { flag: '🇿🇼', fr: 'Zimbabwéenne', ar: 'زيمبابوية', code: 'ZW' },
  { flag: '🇦🇴', fr: 'Angolaise', ar: 'أنغولية', code: 'AO' },
  { flag: '🇳🇦', fr: 'Namibienne', ar: 'ناميبية', code: 'NA' },
  { flag: '🇧☉', fr: 'Botswanaise', ar: 'بوتسوانية', code: 'BW' },
  { flag: '🇱🇸', fr: 'Lesothienne', ar: 'ليسوتية', code: 'LS' },
  { flag: '🇸🇿', fr: 'Eswatinienne', ar: 'إسواتينية', code: 'SZ' },
  { flag: '🇲🇬', fr: 'Malgache', ar: 'مدغشقرية', code: 'MG' },
  { flag: '🇲🇺', fr: 'Mauricienne', ar: 'موريشيوسية', code: 'MU' },
  { flag: '🇸🇨', fr: 'Seychelloise', ar: 'سيشلية', code: 'SC' },
  { flag: '🇨🇻', fr: 'Cap-verdienne', ar: 'الرأس الأخضر', code: 'CV' },
  { flag: '🇸🇳', fr: 'Sénégalaise', ar: 'سنغالية', code: 'SN' },
  { flag: '🇬🇲', fr: 'Gambienne', ar: 'غامبية', code: 'GM' },
  { flag: '🇬🇼', fr: 'Bissaoguinéenne', ar: 'غينيا بيساو', code: 'GW' },
  { flag: '🇬🇳', fr: 'Guinéenne', ar: 'غينية', code: 'GN' },
  { flag: '🇸🇱', fr: 'Sierra-léonaise', ar: 'سيراليونية', code: 'SL' },
  { flag: '🇱🇷', fr: 'Libérienne', ar: 'ليبيرية', code: 'LR' },
  { flag: '🇨🇮', fr: 'Ivoirienne', ar: 'إيفوارية', code: 'CI' },
  { flag: '🇬🇭', fr: 'Ghanéenne', ar: 'غانية', code: 'GH' },
  { flag: '🇹🇬', fr: 'Togolaise', ar: 'توغولية', code: 'TG' },
  { flag: '🇧🇯', fr: 'Béninoise', ar: 'بنينية', code: 'BJ' },
  { flag: '🇧🇫', fr: 'Burkinabé', ar: 'بوركينابية', code: 'BF' },
  { flag: '🇲🇱', fr: 'Malienne', ar: 'مالية', code: 'ML' },
  { flag: '🇳🇪', fr: 'Nigérienne', ar: 'نيجرية', code: 'NE' },
  { flag: '🇹🇩', fr: 'Tchadienne', ar: 'تشادية', code: 'TD' },
  { flag: '🇨🇲', fr: 'Camerounaise', ar: 'كاميرونية', code: 'CM' },
  { flag: '🇨🇫', fr: 'Centrafricaine', ar: 'أفريقيا الوسطى', code: 'CF' },
  { flag: '🇬🇶', fr: 'Équato-guinéenne', ar: 'غينيا الاستوائية', code: 'GQ' },
  { flag: '🇬🇦', fr: 'Gabonaise', ar: 'غابونية', code: 'GA' },
  { flag: '🇨🇬', fr: 'Congolaise', ar: 'كونغولية', code: 'CG' },
  { flag: '🇨🇩', fr: 'Congolaise (RDC)', ar: 'كونغولية ديمقراطية', code: 'CD' },
  { flag: '🇸🇹', fr: 'Santoméenne', ar: 'ساو تومي', code: 'ST' },
  // === Océanie ===
  { flag: '🇦🇺', fr: 'Australienne', ar: 'أسترالية', code: 'AU' },
  { flag: '🇳🇿', fr: 'Néo-zélandaise', ar: 'نيوزيلندية', code: 'NZ' },
  { flag: '🇫🇯', fr: 'Fidjienne', ar: 'فيجية', code: 'FJ' },
  { flag: '🇵🇬', fr: 'Papouasienne', ar: 'بابوا غينيا الجديدة', code: 'PG' },
  { flag: '🇸🇧', fr: 'Salomonaise', ar: 'سليمانية', code: 'SB' },
  { flag: '🇻🇺', fr: 'Vanuatuane', ar: 'فانواتو', code: 'VU' },
  { flag: '🇼🇸', fr: 'Samoane', ar: 'ساموية', code: 'WS' },
  { flag: '🇹🇬', fr: 'Tongienne', ar: 'تونغية', code: 'TO' },
  { flag: '🇰🇮', fr: 'Kiribatienne', ar: 'كيريباتية', code: 'KI' },
  { flag: '🇹🇻', fr: 'Tuvaluane', ar: 'توفالو', code: 'TV' },
  { flag: '🇳🇷', fr: 'Nauruane', ar: 'ناورية', code: 'NR' },
  { flag: '🇵🇼', fr: 'Paluane', ar: 'بالاوية', code: 'PW' },
  { flag: '🇫🇲', fr: 'Micronésienne', ar: 'ميكرونيزية', code: 'FM' },
  { flag: '🇲🇭', fr: 'Marshallaise', ar: 'مارشالية', code: 'MH' },
];
